import { render, staticRenderFns } from "./CustomerClaimManage.vue?vue&type=template&id=b5ee44c6&"
import script from "./CustomerClaimManage.vue?vue&type=script&lang=js&"
export * from "./CustomerClaimManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports